import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsResultsLibrary.module.scss";
import {useSongsResultsLibraryLogic} from "./SongsResultsLibrary.logic";
import {
  SongsPageLibrarySubNavigationItem
} from "../songs-library-sub-navigation-item/SongsPageLibrarySubNavigationItem";
import {LibraryLessonGrid} from "../../../components/songLibrary/LibraryLessonGrid";

export const SongsResultsLibrary: VoidFunctionComponent = () => {
  const {totalSongs, totalFilteredSongs, filteredLessons} = useSongsResultsLibraryLogic();
  return (
    <>
      <nav className={s.subNav}>
        <SongsPageLibrarySubNavigationItem  title={"All"} />
        <SongsPageLibrarySubNavigationItem resultsFilterSubset={`favorites`} title={"Favorites"}  />
      </nav>
      <LibraryLessonGrid
        totalSongs={totalSongs}
        totalFilteredSongs={totalFilteredSongs}
        songArrangements={filteredLessons}
      />
    </>
  );
}
